import { getRgObjectsOfType as f, RG_TYPE as d } from "@project-rouge/rg-core";
function u(o, l, n) {
  let t = 0;
  const s = f(o, d.Building);
  for (const i of s) {
    const r = new Set(i.data.levels.filter((e) => !e.isPodium && !e.isRoof).map((e) => e.levelIndex));
    for (const e of r)
      t += l(i, e, n);
  }
  return t;
}
export {
  u as getMetricFromResidentialLevels
};
//# sourceMappingURL=index6.js.map
